// :cow: Cosmose CONFIDENTIAL :iso:
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, STATE_NAME_SELECT_ADVERTISER } from './select-advertiser.reducer';

const currentState = createFeatureSelector<State>(STATE_NAME_SELECT_ADVERTISER);

export const selectAdvertiserListResponse = createSelector(
  currentState,
  (state: State) => state.response,
);

export const selectAdvertiserListError = createSelector(
  currentState,
  (state: State) => state.responseError,
);

export const selectAdvertiserListShowSkeleton = createSelector(
  currentState,
  (state: State) => state.responseLoading,
);


